export default {
  en: {
    games: {
      baccarat: 'Baccarat',
      baccarat_insurance: 'Baccarat Insurance',
      dragontiger: 'Dragon Tiger',
      dragon_tiger: 'Dragon Tiger',
      hilohitech: 'Sic Bo',
      hilo_hitech: 'Sic Bo',
      hilo_local: 'Hi-Lo Classic',
      keno: 'Keno',
      roulette: 'Roulette',
      sport_soccer: 'Sport Soccer',
      sport_soccer_parlay: 'Sport Soccer Parlay',
      lotto_poipet: 'Poipet Lotto',
      keno_classic: 'Keno Classic',
      money_wheel: 'Money Wheel',
      pokdeng: 'Pokdeng',
      hooheyhow: 'Hoo Hey How',
      fantan: 'Fan Tan',
      bingo: 'Bingo',
      space_lotto: 'Soace lottery',
      aviafish: 'Three Kingdom Fishing'
    },
    messages: {
      round: 'Round',
      limit: 'Limit {limit}',
      playNow: 'Play now',
      bettime: 'Time {time} seconds',
      remains: 'Remains {time} minute',
      spaceLottoLastedResult: 'lasted result {result}',
      unlimitBetTime: 'Unlimit Time',
      userOnline: 'Online {count}',
      break: 'Break Time',
      remaining_chip: 'Chip Balance',
      credit_chip: 'Credit Chip',
      rolling_chip: 'Rolling Chip',
      copied: 'Copied.',
      timeDepositIntelligentReset: 'Cancellations can be made after {minute} minutes.',
      depositInMinute: 'You have a transfer time of {minute} minutes.',
      balanceMustBeDeposit: 'The balance must be transferred.',
      specify_decimal: '* Please specify the decimal.',
      specify_bankAccount: '* Please specify the Account.',
      specify_transfer_time: '* Specify transfer time',
      deposit_guild_condition: '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        '<ol style="margin-left: 16px;">' +
        '<li>กด เลือกธนาคารที่ต้องการโอน</li>' +
        '<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>' +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ</li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้และจะต้องใช้ <u>บัญชีเดียวกันกับที่ลงทะเบียนไว้โอนเข้ามาเท่านั้น</u></span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่ใช้บัญชีที่ลงทะเบียนไว้ จะไม่สามารถปรับยอดได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการใดๆผิด ให้ติดต่อเอเย่นต์ทันที</span></li>' +
        '<li><span class="text-primary">หากรายการสำเร็จระบบจะพาท่านไปยังหน้าประวัติการฝาก-ถอน</span></li>' +
        '<li><span class="text-primary">ห้ามบันทึกบัญชีที่ใช้ในการโอนไว้ใช้ภายหลัง กรุณาทำรายการโอนผ่านหน้านี้เท่านั้น</span></li>' +
        '</ol>',
    },
    form: {
      request: {
        deposit: 'Deposit',
        bank: {
          notfound: 'Bank Not Found'
        },
        ok: 'Ok',
      },
      cancel: 'Cancel',
      bank_name: 'Bank',
      acc_name: 'Account',
      acc_no: 'Account number',
      bank_acc: 'Bank account',
      amount: 'Amount',
      date: 'Date',
      time: 'Time',
      time_a: '',
      remark: 'Remark',
      title: {
        select_account_transfer: 'Transfer Wallet',
        select_account_deposit: 'Choose Bank',
        transfer_with_qrcode: 'Transfer via QR Code',
      },
      published: 'Published'
    },
    navigator: {
      prev: 'Prev',
      next: 'Next'
    }
  },
  th: {
    games: {
      baccarat: 'บาคาร่า',
      baccarat_sixscore: 'บาคาร่า ไม่มีค่าคอมมิชชั่น',
      baccarat_insurance: 'บาคาร่าประกันภัย',
      dragontiger: 'เสือมังกร',
      dragon_tiger: 'เสือมังกร',
      hilohitech: 'ซิกโบ',
      hilo_hitech: 'ซิกโบ',
      hilo_local: 'ไฮโลพื้นบ้าน',
      keno: 'คีโน่',
      roulette: 'รูเล็ต',
      sport_soccer: 'เดิมพันบอลตั๋ว',
      sport_soccer_parlay: 'เดิมพันบอลชุด',
      lotto_poipet: 'ปอยเปตล็อตโต้',
      keno_classic: 'คีโน่ คลาสสิค',
      money_wheel: 'วงล้อพาโชค',
      pokdeng: 'ป๊อกเด้ง',
      hilo_local: 'ไฮโล คลาสสิค',
      hooheyhow: 'น้ำเต้า ปู ปลา',
      fantan: 'กำถั่ว',
      bingo: 'บิงโก',
      space_lottery: 'สเปซล็อตเตอรี่',
      aviafish: 'ยิงปลา สามก๊ก'
    },
    messages: {
      round: 'ตาที่',
      limit: 'จำกัด {limit}',
      playNow: 'เล่นเกมส์',
      bettime: 'เวลา {time} วินาที',
      remains: 'ออกผลใน {time} นาที',
      spaceLottoLastedResult: 'งวดก่อนหน้า {result}',
      unlimitBetTime: 'ไม่จำกัดเวลา',
      userOnline: 'ออนไลน์ {count}',
      break: 'ช่วงพัก',
      remaining_chip: 'จำนวนชิปคงเหลือ',
      credit_chip: 'ชิปเป็น',
      rolling_chip: 'ชิปตาย',
      copied: 'ทำการ copy เรียบร้อย',
      depositInMinute: 'คุณมีเวลาโอนเงินภายในเวลา {minute} นาที',
      balanceMustBeDeposit: 'ยอดที่ต้องโอนคือ',
      specify_decimal: '* โปรดระบุเศษให้ถูกต้อง',
      specify_bankAccount: '* บัญชีที่ต้องโอน',
      specify_transfer_time: '* ระบุเวลาที่โอน',
      timeDepositIntelligentReset: 'สามารถยกเลิกได้หลังจากผ่านไป {minute} นาที',
      deposit_guild_condition: '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        '<ol style="margin-left: 16px;">' +
        '<li>กด เลือกธนาคารที่ต้องการโอน</li>' +
        '<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>' +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ</li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้และจะต้องใช้ <u>บัญชีเดียวกันกับที่ลงทะเบียนไว้โอนเข้ามาเท่านั้น</u></span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่ใช้บัญชีที่ลงทะเบียนไว้ จะไม่สามารถปรับยอดได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการใดๆผิด ให้ติดต่อเอเย่นต์ทันที</span></li>' +
        '<li><span class="text-primary">ห้ามบันทึกบัญชีที่ใช้ในการโอนไว้ใช้ภายหลัง กรุณาทำรายการโอนผ่านหน้านี้เท่านั้น</span></li>' +
        '<li><span class="text-primary">หากรายการสำเร็จระบบจะพาท่านไปยังหน้าประวัติการฝาก-ถอน</span></li>' +
        '</ol>',
    },
    form: {
      transfer_wallet: 'ยืนยันการย้ายเงิน',
      request: {
        deposit: 'เติมเครดิต',
        ok: 'ตกลง',
        bank: {
          notfound: 'ไม่พบบัญชีธนาคาร'
        },
      },
      cancel: 'ยกเลิก',
      acc_name: 'ชื่อบัญชี',
      acc_no: 'เลขบัญชี',
      bank_acc: 'ธนาคาร',
      amount: 'จำนวนเงิน',
      date: 'วันที่',
      time: 'เวลา',
      time_a: 'น.',
      remark: 'ข้อความหมายเหตุ',
      title: {
        select_account_transfer: 'ย้ายกระเป๋าเงิน',
        select_account_deposit: 'เลือกธนาคาร',
        transfer_with_qrcode: 'โอนเงินผ่าน QR Code',

      },
      published: 'เผยแพร่'
    },
    navigator: {
      prev: 'กลับ',
      next: 'ต่อไป'
    }
  },
  kh: {
    games: {
      baccarat: 'Baccarat',
      baccarat_insurance: 'Baccarat Insurance',
      baccarat_sixscore: 'Baccarat no commission',
      dragontiger: 'Dragon Tiger',
      dragon_tiger: 'Dragon Tiger',
      hilohitech: 'Sic Bo',
      hilo_hitech: 'Sic Bo',
      hilo_local: 'Hi-Lo Classic',
      keno: 'Keno',
      roulette: 'Roulette',
      sport_soccer: 'Sport Soccer',
      sport_soccer_parlay: 'Sport Soccer Parlay',
      lotto_poipet: 'Poipet Lotto',
      keno_classic: 'Keno Classic',
      money_wheel: 'Money Wheel',
      pokdeng: 'Pokdeng',
      hooheyhow: 'Hoo Hey How',
      fantan: 'Fan Tan'
    },
    messages: {
      round: 'Round',
      limit: 'Limit {limit}',
      playNow: 'Play now',
      bettime: 'Time {time} seconds',
      unlimitBetTime: 'Unlimit Time',
      userOnline: 'Online {count}',
      break: 'Break Time',
      remaining_chip: 'Chip Balance',
      credit_chip: 'Credit Chip',
      rolling_chip: 'Rolling Chip',
      timeDepositIntelligentReset: 'Cancellations can be made after {minute} minutes.',
      depositInMinute: 'You have a transfer time of {minute} minutes.',
      balanceMustBeDeposit: 'The balance must be transferred.',
      specify_decimal: '* Please specify the decimal.',
      specify_bankAccount: '* Please specify the Account.',
      specify_transfer_time: '* Specify transfer time',
      deposit_guild_condition: '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        '<ol style="margin-left: 16px;">' +
        '<li>กด เลือกธนาคารที่ต้องการโอน</li>' +
        '<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>' +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ</li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้และจะต้องใช้ <u>บัญชีเดียวกันกับที่ลงทะเบียนไว้โอนเข้ามาเท่านั้น</u></span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่ใช้บัญชีที่ลงทะเบียนไว้ จะไม่สามารถปรับยอดได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการใดๆผิด ให้ติดต่อเอเย่นต์ทันที</span></li>' +
        '<li><span class="text-primary">หากรายการสำเร็จระบบจะพาท่านไปยังหน้าประวัติการฝาก-ถอน</span></li>' +
        '<li><span class="text-primary">ห้ามบันทึกบัญชีที่ใช้ในการโอนไว้ใช้ภายหลัง กรุณาทำรายการโอนผ่านหน้านี้เท่านั้น</span></li>' +
        '</ol>',
    },
    form: {
      request: {
        transfer_wallet: 'Confirm Transfer',
        deposit: 'Deposit',
        bank: {
          notfound: 'Bank Not Found'
        },
        ok: 'Ok',
      },
      cancel: 'Cancel',
      bank_name: 'Bank',
      acc_name: 'Account',
      acc_no: 'Account number',
      bank_acc: 'Bank account',
      amount: 'Amount',
      date: 'Date',
      time: 'Time',
      time_a: '',
      remark: 'Remark',
      title: {
        select_account_deposit: 'Choose Bank',
      },
      published: 'Published'
    },
    navigator: {
      prev: 'Prev',
      next: 'Next'
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/messages/system.js